import React from 'react';
import { Grid, TextField, Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import { type SearchParams } from '@/features/researchers/types';
import { TRANSLATION_KEYS } from '@/features/researchers/constants';

interface UserSearchProps {
  searchParams: SearchParams;
  hasActiveSearch: boolean;
  onSearchChange: (field: string, value: string) => void;
  onClearSearch: () => void;
}

/**
 * Component for the user search form
 */
export const UserSearch: React.FC<UserSearchProps> = ({
  searchParams,
  hasActiveSearch,
  onSearchChange,
  onClearSearch,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={3}>
        <TextField
          fullWidth
          label={t(TRANSLATION_KEYS.FIELDS.FIRST_NAME)}
          value={searchParams.firstName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onSearchChange('firstName', e.target.value)
          }
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          fullWidth
          label={t(TRANSLATION_KEYS.FIELDS.LAST_NAME)}
          value={searchParams.lastName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onSearchChange('lastName', e.target.value)
          }
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          fullWidth
          label={t(TRANSLATION_KEYS.FIELDS.EMAIL)}
          value={searchParams.email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onSearchChange('email', e.target.value)
          }
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        {hasActiveSearch && (
          <Button
            onClick={onClearSearch}
            variant="outlined"
            startIcon={<ClearIcon />}
          >
            {t(TRANSLATION_KEYS.SEARCH.CLEAR_BUTTON)}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
